import {getEndpoint, getHeaders} from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_SALES = 'REQUEST_FETCH_STATS_SALES';
export const SUCCESS_FETCH_STATS_SALES = 'SUCCESS_FETCH_STATS_SALES';
export const FAIL_FETCH_STATS_SALES = 'FAIL_FETCH_STATS_SALES';

export const fetchStatsSales = (payload, onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_SALES, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsSales', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_SALES});
        else dispatch({type: SUCCESS_FETCH_STATS_SALES, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_SALES) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/sales.js